import React from 'react';
import styled from 'styled-components';

import { Permissions } from 'components/account/AccountView/users/types';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import useHasPermission from 'hooks/useHasPermission';
import PermissionDisabledTooltip from './PermissionDisabledTooltip';

const DisabledWrapper = styled.div.attrs({
  'aria-disabled': 'true',
  inert: '',
})`
  opacity: 0.5;
  pointer-events: none;
`;

interface PermissionGateProps {
  permission: Permissions | Permissions[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  requireAll?: boolean;
}

export default function PermissionGate({
  permission,
  children,
  fallback,
  requireAll = true,
}: PermissionGateProps): JSX.Element | null {
  const { hasInitialized } = usePSLabs();
  const hasPermission = useHasPermission(permission, requireAll);

  if (!hasInitialized || hasPermission) return <>{children}</>;

  if (fallback !== undefined) return <>{fallback}</>;

  return (
    <PermissionDisabledTooltip>
      <DisabledWrapper>{children}</DisabledWrapper>
    </PermissionDisabledTooltip>
  );
}
